/**
 * Tiny id helper used by every mutation service. Stable enough for a demo,
 * cheap enough to swap for ULID/UUID later without changing call sites.
 */
let counter = 0;
export function newId(prefix: string): string {
  counter += 1;
  const t = Date.now().toString(36);
  const r = Math.random().toString(36).slice(2, 6);
  const c = counter.toString(36);
  return `${prefix}-${t}${r}${c}`;
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .slice(0, 64) || `tournament-${Date.now().toString(36)}`;
}
